import { computed } from 'vue'

import { SellerRole } from '@/enums/seller.ts'
import i18n from '@/libs/i18n'
import { useAppStore } from '@/stores/app.ts'
import type { DropdownType } from '@/types/Common.ts'
import type { Seller, SellerWithPassword } from '@/types/Seller.ts'

const { t } = i18n.global

export const SellerRoles = computed((): DropdownType[] => {
    return [
        { name: t('seller.role.view_all_leads'), value: SellerRole.VIEW_ALL_LEADS },
        { name: t('seller.role.reassign_leads'), value: SellerRole.REASSIGN_LEADS },
        { name: t('seller.role.remove_leads'), value: SellerRole.REMOVE_LEADS },
        { name: t('seller.role.manage_users'), value: SellerRole.MANAGE_USERS }
    ]
})

export const getSellerRole = (value: SellerRole | string): DropdownType => {
    const index = SellerRoles.value.findIndex(x => x.value === value)
    return index > -1 && SellerRoles.value[index] ? SellerRoles.value[index] : { name: '', value: '' }
}

export const hasRoles = (...roles: string[] | SellerRole[]): boolean => {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    const userRoles = useAppStore().getUserData().roles ?? []

    for (const role of roles) {
        if (userRoles.includes(role)) return true
    }

    return false
}

export const getEmptySellerObject = (): Seller => {
    return structuredClone({
        id: '',
        reseller_id: '',
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        roles: [],
        language: ''
    })
}

export const getEmptySellerWithPasswordObject = (): SellerWithPassword => {
    return structuredClone({
        id: '',
        reseller_id: '',
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        roles: [],
        language: '',
        password: ''
    })
}

